import api from '~/services/api';

function getDadosAbertosService() {
  return api.get('DadosAbertos');
}

export { getDadosAbertosService };
